import { get } from 'lodash-es'
const getters = {
  hiddenModules: ({ globalChannelInfo }) => {
    return get(globalChannelInfo, 'otherData.hiddenModule', '') || ''
  },
  cardTypes: ({ cardTypes }) => cardTypes,
  cardOperator: ({ public: { cardId }, globalChannelInfo: { otherData } }) => {
    //所选卡当前运营商
    if (cardId) {
      return otherData.operatorType[cardId]
    } else {
      return ''
    }
  },
  // 是否需要验证码
  hasVerifyCode: ({ globalChannelInfo }) => {
    return globalChannelInfo.otherData.hasVerifyCode
  },

  // 是否有推荐套餐
  // 全局套餐推荐列表
  recommendedPackage: ({ globalChannelInfo }) => {
    return get(globalChannelInfo, 'otherData.fixMealUrlInfo', [])
  },

  // 默认内套餐推荐列表
  recommendedPackageInTemplate: ({ globalChannelInfo }) => {
    return get(globalChannelInfo, 'otherData.mealUrlInfo', [])
  },
  highLight: ({ globalChannelInfo }) => {
    return get(globalChannelInfo, 'otherData.highLight', '')
  },
  //
  // 查看更多按钮
  visibleLookMoreBtn: ({ globalChannelInfo }) => {
    return globalChannelInfo.otherData.detailButtonDisplay
  },

  // 是否展示 icp 备案信息当等于 1 时展示
  isDisplayIcp: ({ globalChannelInfo }) => {
    return globalChannelInfo.otherData.isDisplay === 1
  },

  // 获取协议类型
  operatorType: ({ globalChannelInfo }) => {
    // 联通卡1   移动卡   电信卡3
    return globalChannelInfo.otherData.operatorType
  },

  channel: (state) => state.channel,

  adCodeType: ({ globalChannelInfo }) => {
    return {
      // 代码类型
      codeType: get(globalChannelInfo, 'otherData.codeType', null),
      basicFunc: get(globalChannelInfo, 'otherData.baseCode', null),
      conversionFunc: get(globalChannelInfo, 'otherData.conversionCode', null),
    }
  },
  /**
   * 电信区分 易尊电信
   *
   */
  telecomGsdIsShow: ({ public: { selectCard } }) => {
    return selectCard.proType == '3-yz_card' || selectCard.proType == '3-jt_ns_card'
  },
  /**
   *  2024年1月9日
   * 增加表单展开逻辑
   */
  isShowForm: ({ component: { clickFormExpandBtn } }, getter) => {
    //
    return !clickFormExpandBtn && getter.configModule.includes('50')
  },

  // 模板7 可配置模块
  configModule: ({ globalChannelInfo }) => {
    return get(globalChannelInfo, 'otherData.configModule', '') || ''
    // return '1-1,1-2,1-3,2-1，2-2，3-1，3-2，4-1，4-2，4-3，5，6，7，8，9，10，11，12'
  },
  orderForm: ({ prettyNumber: { shdCache, userInfo, placeOfOwnership } }) => {
    let obj = Object.assign({}, shdCache, userInfo, placeOfOwnership)
    return obj
  },

  /**
   * 子卡逻辑
   */
  isSonCard: ({ public: { selectCard } }) => {
    return selectCard.isCardMain == 0
  },
  cardBinding: ({ public: { selectCard } }) => {
    return selectCard.cardBinding
  },
  /**
   * 宽带业务
   */

  goodsObj: ({ broadband: { goodsObj } }) => {
    return goodsObj
  },
  templateId: ({ globalChannelInfo }) => {
    return get(globalChannelInfo, 'otherData.backgroundImageType', 'default')
  },
  VxgGsdSearchHide: ({ globalChannelInfo, public: { gsdDefault, selectCard } }) => {
    let hiddenModule = get(globalChannelInfo, 'otherData.hiddenModule', '') || ''
    let templateId = get(globalChannelInfo, 'otherData.backgroundImageType', 'default')
    /**
     * 归属地选择框是否显示
     * 条件：
     *
     * 2022-1-31 新增逻辑
     * 模版8 新增判断
     * 隐藏模块10+归宿地省市是否只有一个  || 隐藏模块10+是否为主卡
     *
     *
     *
     * 2023-11-23 新增逻辑
     * 新增小沃卡  1-xw_card
     * 强制隐藏 选择归属地
     */

    if (selectCard.proType == '1-xw_card') {
      return true
    }

    if (hiddenModule && hiddenModule.includes(`10`)) {
      if (templateId == 8) {
        return gsdDefault.btn || selectCard.isCardMain == 1
      } else {
        return gsdDefault.btn
      }
    } else {
      return false
    }
  },
  hunanMurmur: ({ prettyNumber: { HunanTelecomMurmur } }) => {
    return HunanTelecomMurmur
  },

  isProd: ({ prettyNumber: { broadbandIntention } }) => {
    return broadbandIntention
  },
  /**
   * 2023-12-20
   * 新增识别广州电信隐藏选号功能
   */
  isGuangzhouTelecom: ({ public: { selectCard } }) => {
    return selectCard.proType == '3-gzdx_card'
  },
  /**
   * 2024-01-23
   * 新增识别广州电信隐藏选号功能
   */
  isPageWhite: ({ chekaCardCityName, component: { IPCityList } }, getter) => {
    // getter.configModule.includes('51')
    return IPCityList.includes(chekaCardCityName) && getter.configModule.includes('51')
  },
  /**
   * 2024-02-21
   * 获取跳转客服地址
   */

  appLetServiceLink: ({ globalChannelInfo }) => {
    return get(globalChannelInfo, 'otherData.appLetServiceLink', '') || ''
  },
}
export default getters
